import type { PartialTheme } from '@fluentui/theme';
import { getDensityModeString } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getBigActionIconTheme(): PartialTheme {
    const fontSize =
        isFeatureEnabled('mon-densities') && getDensityModeString() === 'full' ? '20px' : '16px;';

    return getBigActionIconStyle(fontSize);
}

const getBigActionIconStyle = (fontSize: string) => {
    return {
        components: {
            IconButton: {
                styles: {
                    root: {
                        height: '100%',
                        width: '28px',
                        marginLeft: '16px',
                    },
                    icon: {
                        // The fluent icon height automatically assigns a line height which we need to override.
                        lineHeight: 'normal',
                        fontSize: fontSize,
                        alignItems: 'center',
                        display: 'flex',
                        marginTop: '3px',
                    },
                    flexContainer: {
                        height: '100%',
                    },
                },
            },
            Icon: {
                styles: {
                    root: {
                        fontSize: fontSize,
                        textAlign: 'center',
                        alignItems: 'center',
                        display: 'flex',
                    },
                },
            },
        },
    };
};
